<template>
    <div class="sf__results__result sf__results__result--group" :class="{'sf__results__result--full-row-label': fullRowLabel}" @click="openOptions">
        <div class="sf__results__result__image">
            <img v-bind:class="{
                'loaded': image_loaded
            }" :src="image" :alt="parts[0].part" @load="image_loaded = true">
        </div>
        <div class="sf__results__result__content">
            <h5 class="sf__results__result__position">{{ formatPosition(parts[0].row) }} - {{ parts[0].side }}</h5>
            <h4 class="sf__results__result__title">{{ parts[0].part }}</h4>
            <p class="sf__results__result__sku">{{ parts.length }} configurations available</p>
            <p class="sf__results__result__price" v-if="startingPrice">
                <span class="sf__results__result__price-prefix">Starting at</span>
                <span>{{ money(startingPrice) }}</span>
            </p>
            <p class="sf__results__result__price" v-else>&nbsp;</p>
        </div>
        <button class="sf__results__result__add-to-cart" @click.stop="openOptions">Select Options</button>
        <PartGroupModal @onClose="closeOptions" v-if="viewingOptions" :parts="parts" />
    </div>
</template>

<script>
import Part from './Part.vue'; 
import PartGroupModal from './PartGroupModal.vue'; 
import store from '../store';
import {formatPartPosition} from '../helpers/helpers';

export default {
    props: ['parts'],

    components: {
        Part, 
        PartGroupModal
    },

    data() {
        return {
            image_loaded: false, 
            viewingOptions: false
        }
    },

    computed: {
        fullRowLabel() {
            return /^(second|third)\b/i.test(this.parts[0].row || '');
        },
        // Let's get the ecommerce image, or we just return the
        // CDN image. 
        image() {
            return store.products[this.parts[0].build_id]?.image
                || this.parts[0].image;
        },

        startingPrice() {
            const prices = this.parts.map(part => {
                const product = store.products[part.build_id];
                const onSale = part.price_sale < part.price && product?.eligible;

                return onSale ? part.price_sale : part.price;
            }).filter(price => Number.isFinite(price));

            if (!prices.length) return null;

            return Math.min(...prices);
        }
    }, 

    methods: {
        money(value) {
            if (!Number.isFinite(value)) return null;
            return '$' + parseFloat(value).toFixed(2);
        },

        formatPosition: formatPartPosition,

        openOptions() {
            this.viewingOptions = true; 
        }, 

        closeOptions() {
            this.viewingOptions = false; 
        }
    }
}
</script>
